import { withTheme } from 'styled-components';
import { Icon } from './icon.component';

export default withTheme(Icon);
